export const CHECKOUT_PAYMENT = 'CHECKOUT/CHECKOUT_PAYMENT';
export const CHECKOUT_PAYMENT_SUCCESS = 'CHECKOUT/CHECKOUT_PAYMENT_SUCCESS';

export const CREATE_TRANSACTION = 'CHECKOUT/CREATE_TRANSACTION';
export const CREATE_TRANSACTION_SUCCESS = 'CHECKOUT/CREATE_TRANSACTION_SUCCESS';

export const CANCEL = 'CHECKOUT/CANCEL';
